module.exports = __webpack_public_path__ + "0acd7dfc03c945c58d07b8aeb7dc81c2.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/termine/Velvetone.jpg
// module id = 582
// module chunks = 0